import _slice from 'lodash/slice';

export const truncateAddress = ({ address, char = 4, charReplace = '****' }: { address: string; char?: number; charReplace?: string }) => {
    const start = _slice(address, 0, char).join('');
    const end = _slice(address, address.length - char).join('');

    return `${start}${charReplace}${end}`;
};
